import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import * as CommonFunctions from 'src/app/shared/commen-function-file';
import { Config } from 'src/app/app-constant';
import { ApproveOrRejectSkipDayComponent } from '../approve-or-reject-skip-day/approve-or-reject-skip-day.component';
import { TimeOnlyPipePipe } from 'src/app/shared/pipe/time-only-pipe.pipe';
import { ReassignTasksComponent } from '../reassign-tasks/reassign-tasks.component';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { DwmattachmentpopupComponent } from '../../My-DWM/dwmattachmentpopup/dwmattachmentpopup.component';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DwmaudittrailComponent } from '../../DWM-Audit-Trail/dwmaudittrail/dwmaudittrail.component';

@Component({
  selector: 'app-review-team-dwm',
  templateUrl: './review-team-dwm.component.html',
  styleUrls: ['./review-team-dwm.component.scss']
})
export class ReviewTeamDwmComponent implements OnInit {
  commonFunctions = CommonFunctions;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  monthsList: string[] = [];
  isAllSelected = false;
  today: Date = new Date();
  disableDelete = false;

  tableState!: TableState<any>;

  selectedFilters: any = {
    selectedEmpId: null,
    selectedYear: null,
    selectedDate: null,
    searchString: null,
    selectedStatus: null,
    selectedCriticality: null,
    isCutoffTaskEditable: null
  };

  listOfYears: any = [];

  checkDwmStatus = this.dwmGenericServiceService?.checkDwmStatus || [];
  checkDwmCriticality = this.dwmGenericServiceService?.checkDwmCriticality || [];
  statusLabelAndValue = this.dwmGenericServiceService?.statusLabelAndValue || [];

  dwmManagerUser: any = null;
  dwmUsers: any = null;
  dwmSkippDay: { applSkipRejectOrAccept: any; isSkipped: boolean; isSkippedText: string; userName: string; empComment: string; date: string; data: any[]; managerComment: string } = {
    applSkipRejectOrAccept: null,
    isSkipped: false,
    isSkippedText: '',
    userName: '',
    empComment: '',
    date: '',
    managerComment: '',
    data: []
  };
  dwmUserTaskList: any = [];
  teamTableHeaders: { label: string; key: string }[] = [
    { label: 'Category', key: 'categoryName' },
    { label: 'Product No', key: 'productNo' },
    { label: 'Plant', key: 'plant' },
    { label: 'Actionable', key: 'actionable' },
    { label: 'Duration', key: 'duration' },
    { label: 'Time From', key: 'timeFrom' },
    { label: 'Time To', key: 'timeTo' },
    { label: 'Frequency', key: 'dwmFrequency' },
    { label: 'Status', key: 'dwmStatus' },
    { label: 'Employee Comment', key: 'employeeComment' },
    { label: 'Manager Comment', key: 'managerComment' },
    { label: 'Attachment', key: 'attachment' },
    { label: 'Audit Trail', key: 'auditTrail' },
    { label: 'Action', key: 'action' }
  ];

  dwmCategories: any = null;
  selectedTaskList: any = [];
  formatedataVariable = CommonFunctions.formatText;
  cuttoffDetails: { getCurrentCuttOffDate: Date | null; getCurrentCuttOffDateInMs: number | null } | null = {
    getCurrentCuttOffDate: null,
    getCurrentCuttOffDateInMs: null
  };

  checkIfIsRNDOrL4AndAboveEmployee: any = null;
  getAllDwmTypes: any = [];
  isExitedSelectedDate: any = null;
  exitedMode = false;
  employeeDropdownList: any = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public sharedService: SharedService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    private datePipe: DatePipe,
    private timeOnlyPipePipe: TimeOnlyPipePipe,
    public dwmGenericServiceService: DwmGenericServiceService,
    public getCompanyAndUsersData: GetCompanyAndUsersData,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.exitedMode = !!this.activatedRoute.snapshot?.data?.['exitedOnly'];

    this.dwmGenericServiceService.getDWMSetup().subscribe((res: any) => {
      this.cuttoffDetails = this.dwmGenericServiceService.checkGetDWMSetup(res);
    });

    this.loggedInUserCompanyID = this.getCompanyAndUsersData.loggedInUserCompanyID;
    this.loggedInUserId = this.getCompanyAndUsersData.loggedInUserId;

    this.monthsList = this.genericService.allMonth;
    this.selectedFilters.selectedYear = this.selectedYear();
    this.listOfYears = this.getCompanyAndUsersData.getAllFinancialYears;
    this.selectedFilters.selectedDate = this.genericService.getTodaysDate;

    this.generateData();
  }

  selectedYear() {
    return this.getCompanyAndUsersData.convertFinancialYear(this.getCompanyAndUsersData?.loggedInCompanyFiscalyear || '', 'yearTextToNumber', '_');
  }

  generateData() {
    this.resetAllSelectedTasks();
    this.dwmUserTaskList = [];
    this.tableState = this.dwmGenericServiceService.init([], this.pageSize);
    this.dwmSkippDay = {
      applSkipRejectOrAccept: null,
      isSkipped: false,
      isSkippedText: '',
      data: [],
      empComment: '',
      userName: '',
      managerComment: '',
      date: ''
    };

    // exited page: no date, so the server returns all dates of the selected employee
    const getStartAndEdnDate = this.exitedMode ? '' : this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate);
    this.checkIfIsRNDOrL4AndAboveEmployee = this.getCompanyAndUsersData.checkIfIsRNDOrL4AndAboveEmployee(this.selectedFilters?.selectedEmpId);
    this.getAllDwmTypes = this.dwmGenericServiceService.getDwmType(this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove);

    this.isExitedSelectedDate = this.dwmGenericServiceService.checkIfIsExitedSelectedDate(this.selectedFilters.selectedDate);

    const request = {
      companyId: this.loggedInUserCompanyID,
      userId: this.loggedInUserId,
      from: getStartAndEdnDate,
      to: getStartAndEdnDate,
      date: null,
      toYear: null,
      fromYear: null,
      userType: null,
      yearRange: null
    };

    // console.log('asdfas adsadf asd getStartAndEdnDate', getStartAndEdnDate);
    this.selectedFilters.isCutoffTaskEditable = this.exitedMode ? true : this.dwmGenericServiceService.isCreateTaskEnabled(getStartAndEdnDate, this.cuttoffDetails?.getCurrentCuttOffDate);

    forkJoin({
      // getTeamMembers: this.httpService.callPostService(this.config.getTeamOfManagerForDWm, request),
      getTeamMembers: this.httpService.callGetService(`${this.config.getExitedEmployeeUnderManager}?companyId=${this.loggedInUserCompanyID}&managerCode=${this.getCompanyAndUsersData.loggedInUserEmpCode}`),
      // exited page: load nothing until an employee is chosen (otherwise the server would return every task of the company), and send no date at all
      dwmTransactionData:
        this.exitedMode && !this.selectedFilters?.selectedEmpId
          ? of({ status: true, data: [] })
          : this.httpService.callGetService(this.exitedMode ? `${this.config.getDwmUpdate}?companyId=${this.loggedInUserCompanyID}&userId=${this.selectedFilters?.selectedEmpId}&includeFrequency=true` : `${this.config.getDwmUpdate}?companyId=${this.loggedInUserCompanyID}&userId=${this.selectedFilters?.selectedEmpId || ''}&dwmEventDate` + `=${getStartAndEdnDate}`),
      getCategoriesList: this.httpService.callGetService(`${this.config.getCategoriesList}?companyId=${this.loggedInUserCompanyID}`),
      dwmSkipDayData: this.httpService.callGetService(`${this.config.getSkipDay}?companyId=${this.loggedInUserCompanyID}`)
    }).subscribe({
      next: (data: any) => {
        // this.dwmManagerUser = data?.getTeamMembers?.status ? data?.getTeamMembers?.data : [];
        // active employees first, exited employees last (they get their own group in the dropdown)
        this.dwmManagerUser = (data?.getTeamMembers?.status ? data.getTeamMembers.data.map((u: any) => ({ ...u, id: Number(u.id) })) : []).sort((a: any, b: any) => Number(a.empStatus == '0') - Number(b.empStatus == '0'));
        // dropdown list: the whole team on Review, only exited employees on the Exited page (dwmManagerUser keeps the whole team)
        if (this.exitedMode) {
          // exited page: only exited employees who still have tasks to reassign (the list is narrowed once their tasks are checked)
          if (!this.employeeDropdownList) this.employeeDropdownList = [];
          this.keepExitedEmployeesWithOpenTasks(this.dwmManagerUser.filter((u: any) => u.empStatus == '0'));
        } else {
          // Review lists only active employees; exited employees are handled on the Exited Team DWM page
          this.employeeDropdownList = this.dwmManagerUser.filter((u: any) => u.empStatus != '0');
        }
        this.dwmUsers = data?.dwmTransactionData?.status ? this.dwmGenericServiceService.sortByIdDesc(data?.dwmTransactionData?.data) : [];
        // this.dwmCategories = data?.getCategoriesList?.status ? data?.getCategoriesList?.data : [];
        this.dwmCategories = data?.getCategoriesList?.status ? data?.getCategoriesList?.data.map((item: any) => ({ ...item, categoryName: item.categoryName?.trim() })).filter((item: any) => (this.checkIfIsRNDOrL4AndAboveEmployee.isRnd ? true : item.categoryName !== 'R&D')) : [];

        // collect all team user IDs
        const teamUserIds = this.dwmManagerUser.map((user: any) => user.id);
        const { selectedStatus, selectedCriticality } = this.selectedFilters;
        const filteredDwmUsersData = this.dwmUsers
          .filter((item: any) => teamUserIds.includes(item.userId))
          .filter((item: any) => {
            const hasStatusFilter = selectedStatus !== null && selectedStatus !== undefined;
            const hasCriticalityFilter = selectedCriticality !== null && selectedCriticality !== undefined;
            const statusMatch = hasStatusFilter ? (selectedStatus === 'Done_with_delay' ? item?.doneWithDelay === true : item?.dwmStatus === selectedStatus) : true;
            const criticalityMatch = hasCriticalityFilter ? item?.isCriticalTask == (selectedCriticality === 'Critical') : true;
            return statusMatch && criticalityMatch;
          });

        filteredDwmUsersData.forEach((filteredDwmData: any) => {
          // exited page: every date is shown, only tasks that still need reassigning (open ones), and the team list decides which employees are visible (not the approver)
          const getDataAsPerMonthAndYear = this.exitedMode ? true : this.getCompanyAndUsersData.getDateInMs(getStartAndEdnDate) == this.getCompanyAndUsersData.getDateInMs(filteredDwmData?.dwmEventDate);
          const statusesToShow = this.exitedMode ? ['Not_Started', 'In_Progress'] : this.checkDwmStatus;

          const exitedUser = this.dwmManagerUser.find((u: any) => u.id == this.selectedFilters.selectedEmpId);

          if (statusesToShow.includes(filteredDwmData?.dwmStatus) && filteredDwmData?.userId == this.selectedFilters.selectedEmpId && (this.exitedMode || filteredDwmData?.managerId == this.loggedInUserId) && getDataAsPerMonthAndYear && (!this.exitedMode || this.isAfterExit(exitedUser, filteredDwmData?.dwmEventDate))) {
            // Table Data
            this.dwmUserTaskList.push({
              checkboxCheck: false,

              id: filteredDwmData?.id || '',
              companyId: filteredDwmData?.companyId || '',
              userId: filteredDwmData?.userId || '',
              managerId: filteredDwmData?.managerId || '',

              dwmMasterId: filteredDwmData?.dwmMasterId || '',
              categoryId: filteredDwmData?.categoryId || '',
              productId: filteredDwmData?.productId || '',
              actionable: filteredDwmData?.actionable || '',
              plantLocation: filteredDwmData?.plantLocation || '',
              dwmEventDate: filteredDwmData?.dwmEventDate || '',
              dwmDuration: filteredDwmData?.dwmDuration || '',
              timeFrom: filteredDwmData?.timeFrom || '',
              timeTo: filteredDwmData?.timeTo || '',
              empComments: filteredDwmData?.empComments || '',
              managerComments: filteredDwmData?.managerComments || '',
              dwmDoc: filteredDwmData?.dwmDoc || '',
              isCriticalTask: filteredDwmData?.isCriticalTask || '',
              dwmStatus: filteredDwmData?.dwmStatus,

              dwmFrequency: filteredDwmData?.dwmFrequency?.toUpperCase()?.replace('_', '-') || '',
              categoryName: this.dwmCategories.find((cat: any) => cat.categoryId === filteredDwmData?.categoryId)?.categoryName || '',
              dwmStatusIsCompleted: filteredDwmData?.dwmStatus == 'Completed' || false,
              doneWithDelay: filteredDwmData?.doneWithDelay, //done with delay
              checkIfIsRNDEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isRnd,
              checkIfIsL4AndAboveEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove,
              _prevComment: filteredDwmData?.managerComments,
              isCutoffTaskEditable: this.dwmGenericServiceService.isCreateTaskEnabled(filteredDwmData?.dwmEventDate, this.cuttoffDetails?.getCurrentCuttOffDate),
              hasSavedAttachments: null
            });
          }
        });

        if (this.exitedMode) this.groupExitedTasks();

        if (data?.dwmSkipDayData?.status) {
          for (const skipData of data?.dwmSkipDayData?.data) {
            const matchDate = this.getCompanyAndUsersData.getDateInMs(getStartAndEdnDate) == this.getCompanyAndUsersData.getDateInMs(skipData.dwmDate);
            if (matchDate && +skipData.userId == +this.selectedFilters.selectedEmpId) {
              if (!this.dwmSkippDay?.isSkipped) {
                const userName = this.dwmManagerUser.find((user: any) => +user.id == +skipData.userId);
                skipData.managerId = this.loggedInUserId;

                this.dwmSkippDay.applSkipRejectOrAccept = skipData?.isSkipped !== null;
                this.dwmSkippDay.isSkipped = true;
                this.dwmSkippDay.isSkippedText = skipData.isSkipped ? '<span class="clr-green">The Day is Skipped</span>' : skipData.isSkipped == null ? '<span class="clr-blue">Applied for Skip Day</span>' : '<span class="clr-red">Skip Day Rejected</span>';
                this.dwmSkippDay.userName = userName.firstName + ' ' + userName.lastName;
                this.dwmSkippDay.empComment = skipData.reason;
                this.dwmSkippDay.managerComment = skipData.managerComment;
                this.dwmSkippDay.date = skipData.dwmDate;
              }
              this.dwmSkippDay.data = [...this.dwmSkippDay.data, skipData];
            }
          }
          this.dwmSkippDay.data = this.dwmSkippDay.data.filter((b: any) => this.dwmUserTaskList.some((a: any) => a.id === b.transactionId));
        }

        // console.log('this.dwmUserTaskList - - - - -   ', this.dwmUserTaskList);
        // Initialize table
        this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
      }
    });
  }

  // Exited page: a task counts only if its date is after the employee's date of exit (no exit date = show it)
  private isAfterExit(user: any, eventDate: any): boolean {
    const exitDate = user?.dateOfExit ? String(user.dateOfExit).substring(0, 10) : null;
    return !exitDate || String(eventDate).substring(0, 10) > exitDate;
  }

  // Exited page: one line per task (master); the open dates stay inside the line so Assign moves all of them
  private groupExitedTasks() {
    const groups = new Map<any, any>();
    this.dwmUserTaskList.forEach((task: any) => {
      const group = groups.get(task.dwmMasterId);
      if (!group) {
        groups.set(task.dwmMasterId, { ...task, actionable: task.actionable?.replace(/\s+\d{1,2}-[A-Za-z]{3}-\d{4}$/, ''), groupRows: [task], openCount: 1 });
      } else {
        group.groupRows.push(task);
        group.openCount++;
      }
    });
    this.dwmUserTaskList = Array.from(groups.values()).map((group: any) => {
      const dates = group.groupRows.map((row: any) => String(row.dwmEventDate).substring(0, 10)).sort();
      return { ...group, dateFrom: dates[0], dateTo: dates[dates.length - 1], dateList: dates.join(', ') };
    });
  }

  private keepExitedEmployeesWithOpenTasks(exitedEmployees: any[]) {
    if (!exitedEmployees.length) {
      this.employeeDropdownList = [];
      return;
    }

    forkJoin(exitedEmployees.map((u: any) => this.httpService.callGetService(`${this.config.getDwmUpdate}?companyId=${this.loggedInUserCompanyID}&userId=${u.id}&includeFrequency=true`))).subscribe({
      next: (responses: any) => {
        const openStatuses = ['Not_Started', 'In_Progress'];
        this.employeeDropdownList = exitedEmployees.filter((u: any, i: number) => (responses[i]?.status ? responses[i].data : []).some((t: any) => +t.userId === +u.id && openStatuses.includes(t.dwmStatus) && this.isAfterExit(u, t.dwmEventDate) && this.dwmGenericServiceService.isCreateTaskEnabled(t.dwmEventDate, this.cuttoffDetails?.getCurrentCuttOffDate)));

        // the selected employee has nothing left to reassign: clear the selection and the table
        if (this.selectedFilters.selectedEmpId && !this.employeeDropdownList.some((u: any) => u.id == this.selectedFilters.selectedEmpId)) {
          this.selectedFilters.selectedEmpId = null;
          this.dwmUserTaskList = [];
          this.tableState = this.dwmGenericServiceService.init([], this.pageSize);
        }
      },
      error: () => {
        this.employeeDropdownList = exitedEmployees; 
      }
    });
  }

  // Employee dropdown: exited employees are listed under an "Exited employees" header, active ones have no header
  groupByExitStatus = (item: any) => {
    if (this.exitedMode) return undefined; 
    const id = typeof item === 'object' ? item?.id : item;
    return this.dwmManagerUser?.find((u: any) => u.id == id)?.empStatus == '0' ? 'Exited' : undefined;
  };

  applyDataFilters(event: any, filterName: any, applyFilter: boolean = true) {
    if (applyFilter) {
      this.selectedFilters[filterName] = event;
    } else {
      this.selectedFilters = {
        selectedEmpId: null,
        selectedYear: this.selectedYear(),
        selectedDate: this.genericService.getTodaysDate,
        searchString: null,
        selectedStatus: null,
        selectedCriticality: null
      };
    }
    this.generateData();
    this.isAllSelected = false;
  }

  // ================================== Audit popup ======================================

  auditpopup(taskId: number | null) {
    const dialogRef = this.dialog.open(DwmaudittrailComponent, {
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {
        taskId: taskId // Pass the task ID to the audit component
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  hasNewEntry = false;
  selectALLDwms(event: any, paginatedData: any) {
    this.hasNewEntry = false;
    this.selectedTaskList = [];
    paginatedData.forEach((record: any) => (record.checkboxCheck = false));
    if (event?.checked) {
      paginatedData.forEach((record: any, index: number) => {
        if (this.checkDwmStatus.includes(record?.dwmStatus)) {
          if (record?.dwmStatus == 'Completed') this.disableDelete = true;
          record.checkboxCheck = true;
          this.selectedTaskList.push({ index, item: record });
        }
      });
    }

    this.isAllSelected = event?.checked ?? false;
    this.hasNewEntry = this.selectedTaskList.some((x: any) => x.item?.isNew === true);
  }

  selectSingleDwm(event: any, item: any, index: number) {
    this.disableDelete = this.hasNewEntry = false;
    if (this.selectedTaskList?.length)
      this.selectedTaskList.map((data: any) => {
        if (data.item.dwmStatus == 'Completed') this.disableDelete = true;
      });

    if (event?.checked) {
      if (!this.selectedTaskList.some((t: any) => t.item.id === item.id)) this.selectedTaskList.push({ index, item });
    } else {
      this.selectedTaskList = this.selectedTaskList.filter((task: any) => task.item.id !== item.id);
    }
    this.isAllSelected = this.paginatedData?.length > 0 && this.paginatedData.every(r => r.checkboxCheck);
    this.hasNewEntry = this.selectedTaskList.some((x: any) => x.item?.isNew === true);
  }

  onClickSkipDay() {
    this.dialog
      .open(ApproveOrRejectSkipDayComponent, {
        data: this.dwmSkippDay,
        maxWidth: '500px',
        panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh']
      })
      .afterClosed()
      .subscribe((data: any) => {
        if (data) this.generateData();
      });
  }

  downloadReport(downloadType: string) {
    const source = this.tableState?.filteredData || [];

    if (!source?.length) {
      this.toastr.warning('No task data to export!');
      return;
    }

    if (downloadType === 'excel') {
      const data = source.map(task => {
        return {
          Category: task?.categoryName || '',
          'Product Id': task?.productId || '',
          'Plant Location': task?.plantLocation || '',
          Actionable: task?.actionable || '',
          'Dwm Duration': task?.dwmDuration || '',
          'Time From': task?.timeFrom ? this.timeOnlyPipePipe.transform(task.timeFrom) : '',
          'Time To': task?.timeTo ? this.timeOnlyPipePipe.transform(task.timeTo) : '',
          Frequency: task?.dwmFrequency || '',
          Status: task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : '',
          'Emp Comments': task?.empComments || '',
          'Manager Comments': task?.managerComments || '',
          Attachment: task?.dwmDoc || ''
        };
      });
      this.dwmGenericServiceService.saveAsExcelFile(data, 'Review Team DWM', 'review_team_dwm');
    }

    if (downloadType === 'pdf') {
      let pdfTableHeaders: string[] = [];
      this.teamTableHeaders.map((header: any) => {
        if (!(header?.key == 'auditTrail' || header?.key == 'action')) pdfTableHeaders.push(header.label);
      });
      const data = source.map(task => {
        return [task?.categoryName || '', task?.productId || '', task?.plantLocation || '', task?.actionable || '', task?.dwmDuration || '', task?.timeFrom ? this.timeOnlyPipePipe.transform(task.timeFrom) : '', task?.timeTo ? this.timeOnlyPipePipe.transform(task.timeTo) : '', task?.dwmFrequency || '', task?.dwmStatus ? this.dwmGenericServiceService.getStatusLabel(task.dwmStatus) : '', task?.empComments || '', task?.managerComments || '', task?.dwmDoc || ''];
      });
      this.dwmGenericServiceService.downloadTableAsPdf(pdfTableHeaders, data, 'Review Team DWM', 'review_team_dwm');
    }
  }

  resetAllSelectedTasks() {
    this.selectedTaskList = [];
    this.isAllSelected = false;
  }
  /* Filers */
  onSearch(event: Event | null) {
    const value = (event?.target as HTMLInputElement)?.value || '';
    this.tableState = this.dwmGenericServiceService.applyFilter(this.tableState, value);
    this.resetAllSelectedTasks();
  }
  onSort(column: string) {
    this.tableState = this.dwmGenericServiceService.sort(this.tableState, column);
  }
  changePage(page: number) {
    this.tableState = this.dwmGenericServiceService.changePage(this.tableState, page);
    this.resetAllSelectedTasks();
  }
  changePageSize(size: number): void {
    this.tableState = this.dwmGenericServiceService.changePageSize(this.tableState, size);
    this.resetAllSelectedTasks();
  }

  get paginatedData() {
    if (!this.tableState) return [];
    return this.dwmGenericServiceService.paginate(this.tableState);
  }

  get totalEntries() {
    return this.dwmGenericServiceService.totalEntries(this.tableState);
  }

  get totalPages() {
    return this.dwmGenericServiceService.totalPages(this.tableState);
  }

  get startEntry() {
    return this.dwmGenericServiceService.startEntry(this.tableState);
  }

  get endEntry() {
    return this.dwmGenericServiceService.endEntry(this.tableState);
  }

  get currentPage(): number {
    return this.tableState?.currentPage ?? 1;
  }

  get pageSize(): number {
    return this.tableState?.pageSize ?? 25;
  }
  /* End Filers */

  // Additional On change filters

  checkMaxLength(data: any) {
    this.dwmGenericServiceService.checkMaxLength(data);
  }

  /* Update Status and Manager comment */

  changeStatusOrComment(item: any, status: string): void {
    // if (item?.isNew) return;
    if (item?.dwmStatus === status || this.dwmSkippDay?.empComment === 'Accept skip day' || !item?.isCutoffTaskEditable) return;
    if (item?.categoryName == 'R&D') {
      this.saveOrUpdateRNDTask(item, status);
    } else {
      this.saveUpdateDWM(item, status);
    }
  }

  saveUpdateDWM(item: any, status?: string): void {
    const getStatus = status || item.dwmStatus;
    const payload = [
      {
        managerComments: item?.managerComments || null,
        dwmStatus: getStatus == 'Done_with_delay' ? 'Completed' : getStatus,

        id: item?.id || null,
        dwmMasterId: item?.dwmMasterId || null,
        companyId: item?.companyId || null,
        categoryId: item?.categoryId || null,
        actionable: item?.actionable || null,
        timeFrom: item?.timeFrom || null,
        timeTo: item?.timeTo || null,
        dwmFrequency: null,
        dwmMonth: item?.dwmMonth || null,
        dwmDate: item?.dwmEventDate || null,
        managerId: item?.managerId || null,
        isCriticalTask: item?.isCriticalTask || null,
        doneWithDelay: status == 'Done_with_delay' ? true : null,
        dwmDoc: item.attachments?.join(',') || null
      }
    ];

    this.httpService.callPostService(this.config.updateDWM, payload).subscribe({
      next: (data: any) => {
        if (data?.status) {
          if (status) item.dwmStatus = status;
          this.toastr.success(item.id ? 'Updated successfully' : 'Saved successfully');
          item.isEdit = false;
        }
      },
      error: () => {
        this.toastr.error('Save failed');
      }
    });
  }

  saveOrUpdateRNDTask(item: any, status?: any) {
    const payload = [
      {
        id: item?.id, // supports update also
        dwmStatus: status == 'Done_with_delay' ? 'Completed' : status || null,
        companyId: item?.companyId || null,
        userId: Number(item?.userId) || null,
        managerId: item?.managerId || null,
        categoryId: item?.categoryId || null,
        plantLocation: item?.plantLocation || null,
        productId: item?.productId || null,
        actionable: item?.actionable || null,
        dwmEventDate: item?.dwmEventDate || null,
        dwmDuration: item?.dwmDuration || null,
        empComments: item?.empComments || null,
        dwmDoc: item?.attachments ? item?.attachments?.join(',') : null,
        isCriticalTask: item?.isCriticalTask || null,
        managerComments: item?.managerComments || null
      }
    ];

    this.httpService.callPostService(this.config.saveRNDEmployee, payload).subscribe({
      next: (data: any) => {
        if (status) item.dwmStatus = status;
        if (data?.status) this.toastr.success('Updated Successfully');
      },
      error: (err: any) => {
        this.toastr.warning(err?.error?.message || 'Save failed', 'Warning');
      }
    });
  }

  onClickDeleteRecord() {
    if (!this.selectedTaskList?.length) return;

    const selectedUserName = this.dwmManagerUser.find((user: any) => user.id == this.selectedFilters.selectedEmpId);
    const selectedDate = this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate);

    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to delete selected tasks for ${selectedUserName.firstName + ' ' + selectedUserName.lastName} on ${selectedDate}? This action cannot be undone.` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          const payload = {
            companyId: this.getCompanyAndUsersData.loggedInUserCompanyID,
            ids: this.selectedTaskList.map((data: any) => data.item.id)
          };

          this.httpService.callPostService(this.config.updateDeleteTasks, payload).subscribe({
            next: (data: any) => {
              if (data?.status) {
                this.toastr.success(data?.message);
                this.generateData();
              } else {
                this.toastr.error('Deletion failed');
              }
            },
            error: () => {
              this.toastr.error('Deletion failed');
            }
          });
        }
      });
  }

  resignSelectDwms() {
    if (!this.selectedTaskList?.length) {
      this.toastr.warning('Please select at least one task');
      return;
    }

    const records = this.selectedTaskList.flatMap((x: any) => (this.exitedMode ? x.item.groupRows : [x.item]));
    const selectedUserName = this.dwmManagerUser.find((user: any) => user.id == this.selectedFilters.selectedEmpId);

    this.dialog
      .open(ReassignTasksComponent, {
        data: {
          selectedEmpId: this.selectedFilters?.selectedEmpId,
          dwmManagerUser: this.exitedMode ? this.dwmManagerUser.filter((u: any) => u.empStatus != '0') : this.dwmManagerUser,
          exitedMode: this.exitedMode,
          userName: selectedUserName.firstName + ' ' + selectedUserName.lastName,
          resignData: records,
          selectedDate: this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate)
        },
        maxWidth: '500px',
        panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh', 'mx-h60vh']
      })
      .afterClosed()
      .subscribe((data: any) => {
        if (data) this.generateData();
      });
  }

  showMtdView() {
    this.dwmGenericServiceService.showMtdView.next({ userId: this.selectedFilters.selectedEmpId });
    // this.dwmGenericServiceService.changeTabByLabel('reports');
    this.router.navigate(['dwm-reports'], { relativeTo: this.activatedRoute.parent });
  }

  onDownload(item: any) {
    // console.log(item);
    this.dialog.open(DwmattachmentpopupComponent, {
      data: { attachments: item?.dwmDoc?.split(',') },
      maxWidth: '767px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh', 'mx-h60vh']
    });
  }

  addRNDTask() {
    /* 
    Editable fields
      - Actionable
      - Product No
        - auto populated plant
      - Duration
      - Date
      - status 
      - Employee comment
      - upload doc
      - Audit trail 
      - Action save/delete 
    */
    // console.log(this.dwmCategories);
    this.dwmUserTaskList.unshift({
      id: this.dwmGenericServiceService.generateUniqueIdByExistingList(this.dwmUserTaskList),
      isNew: true,
      checkboxCheck: false,
      userId: this.selectedFilters.selectedEmpId,
      managerId: +this.loggedInUserId,
      companyId: this.getCompanyAndUsersData.loggedInUserCompanyID,
      dwmYear: this.getCompanyAndUsersData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedFilters.selectedYear, this.dwmGenericServiceService.getMonthName(this.selectedFilters.selectedDate)),
      fiscalYear: this.getCompanyAndUsersData?.loggedInCompanyFiscalyear,
      categoryName: 'R&D-Project',
      categoryId: null,
      dwmStatus: 'Not_Started',

      empComments: null,

      dwmType: this.selectedFilters.selectedDwmType,
      dwmFrequency: null,
      isRepetativeTask: true,

      dwmMonth: null,
      dwmDate: null,
      timeFrom: '',
      timeTo: '',
      actionable: null,
      isCriticalTask: null,
      managerComments: null,

      checkIfIsRNDEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isRnd,
      checkIfIsL4AndAboveEmployee: this.checkIfIsRNDOrL4AndAboveEmployee.isL4AndAbove,
      isRequiredCategory: false,
      isRequiredActionable: false,
      isRequiredDwmDate: false,
      isCutoffTaskEditable: true,

      productId: null,
      plantLocation: null
    });

    this.selectedTaskList = [];
    this.isAllSelected = false;

    // console.log('this.dwmUserTaskList - - - - - * -', this.dwmUserTaskList);
    this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
  }

  saveRNDTask() {
    // console.log(this.selectedTaskList, this.selectedFilters);
    const saveData = this.selectedTaskList?.length ? this.selectedTaskList.filter((x: any) => x?.item?.isNew === true).map((x: any) => x.item) : this.dwmUserTaskList.filter((x: any) => x.isNew === true);

    // console.log('- - - - saveData - - - - ', saveData);
  }

  saveRNDTaskApiCall(tasksToSave: any) {
    // const tasksToSave = this.dwmUpdateData.filter(t => t.isNew === true);
    // const tasksToSave = this.dwmUpdateData.filter(t => t.categoryName === 'R&D');

    if (!tasksToSave.length) {
      this.toastr.warning('No new task to save');
      return;
    }

    const payload = tasksToSave.map((task: any) => {
      const normalizeDuration = (val: string | null): string | null => {
        if (!val) return null;

        // If only hours (e.g. "22")
        if (/^\d{1,2}$/.test(val)) {
          return val.padStart(2, '0') + ':00';
        }

        // If HH:m → HH:0m
        if (/^\d{1,2}:\d{1}$/.test(val)) {
          const [h, m] = val.split(':');
          return h.padStart(2, '0') + ':' + m.padStart(2, '0');
        }

        // Already valid HH:mm
        return val;
      };

      const selectedProduct = this.productList.find((p: any) => p.productNumber === task.productNumber);

      return {
        id: null,
        companyId: this.loggedInUserCompanyID,
        userId: this.selectedFilters.selectedEmpId,
        managerId: null,

        categoryId: 30, // R&D
        plantLocation: task.plantLocation,

        productId: selectedProduct?.productId ?? null,

        actionable: task.actionable ?? null,

        dwmEventDate: task.dwmEventDate ? this.dwmGenericServiceService.formatDate(this.selectedFilters.selectedDate) : null,

        dwmDuration: normalizeDuration(task.dwmDuration),

        empComments: task.empComments ?? null,

        dwmStatus: task.dwmStatus,

        dwmDoc: task.attachments?.join(',') || null,

        isCriticalTask: false
      };
    });

    this.httpService.callPostService(this.config.saveRNDEmployee, payload).subscribe({
      next: (res: any) => {
        this.toastr.success('Saved Successfully');

        this.generateData();
      },
      error: (err: any) => {
        const errorMsg = err?.error?.message || 'Save failed';
        this.toastr.warning(errorMsg, 'Warning');
      }
    });
  }

  removeTask(index: any) {
    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to discard the changes?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.dwmUserTaskList.splice(index, 1);
          this.tableState = this.dwmGenericServiceService.init(this.dwmUserTaskList, this.pageSize);
        }
      });
  }
  refreshData() {
    this.generateData();
  }

  // Upload document
  uploadDWMAttachments(event: any, item: any): void {
    // console.log(item);
    const files: FileList = event?.target?.files;

    if (!files || files.length === 0) return;

    // -------- File size validation (10MB) --------
    for (let i = 0; i < files.length; i++) {
      const sizeInMB = files[i].size / (1024 * 1024);
      if (sizeInMB > 10) {
        this.toastr.error('File size should not exceed 10MB');
        return;
      }
    }

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
      formData.append('fileType', files[i].type.split('/')[0]);
    }

    this.loader.simpleLoader();

    const url = this.config.uploadFileLocallymultipleForPMS;
    this.httpService.submitFormService(url, formData).subscribe({
      next: (res: any) => {
        this.loader.dismissLoader();
        const uploadedPaths = res?.data || [];
        item.attachments = [...(item.attachments || []), ...uploadedPaths];
        item.hasSavedAttachments = item.attachments.length > 0;
        item.dwmDoc = item.attachments?.join(',') || null;
      },
      error: () => {
        this.loader.dismissLoader();
        this.toastr.error('Attachment upload failed');
      }
    });
  }

  removeSavedAttachments(item: any): void {
    item.attachments = [];
    item.dwmDoc = null;
    item.hasSavedAttachments = false;
    this.saveUpdateDWM(item, '');
  }

  // Product
  productList: any[] = [];
  getProductsData() {
    this.httpService.callGetService(`${this.config.getProducts}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      // console.log('Products Data :', res);
      this.productList = (res?.data || []).map((p: any) => ({
        ...p,
        productNumber: p.productNo
      }));
    });
  }
  onProductChange(item: any): void {
    const selectedProduct = this.productList.find(p => p.productId === item.productId);

    if (!selectedProduct) {
      item.productNumber = null;
      item.plantLocation = '';
      return;
    }

    item.productNumber = selectedProduct.productNumber;
    item.plantLocation = selectedProduct.plantLocation;
  }

  // Duration
  maxDurationError = false;
  onDurationInput(item: any, event?: Event) {
    // ---------------- BLOCK INVALID KEYS ----------------
    if (event && event.type === 'keydown') {
      const keyboardEvent = event as KeyboardEvent;

      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

      if (allowedKeys.includes(keyboardEvent.key)) {
        return;
      }

      // Block everything except numbers
      if (!/^\d$/.test(keyboardEvent.key)) {
        keyboardEvent.preventDefault();
        return;
      }
    }

    let value = item.dwmDuration || '';
    this.maxDurationError = false;
    //  Remove everything except digits
    value = value.replace(/\D/g, '');

    //  Insert colon after hours
    if (value.length > 2) {
      value = value.slice(0, value.length - 2) + ':' + value.slice(-2);
    }

    let [hours, minutes] = value.split(':');

    // Limit hours length
    if (hours && hours.length > 2) {
      hours = hours.slice(0, 2);
    }

    // Convert to numbers for validation
    const h = Number(hours);
    const m = minutes ? Number(minutes) : 0;

    // ---------- VALIDATION : MAX 24:00 ----------
    if (h > 24 || (h === 24 && m > 0)) {
      this.maxDurationError = true;

      // Stop further input
      if (event && event.type === 'keydown') {
        (event as KeyboardEvent).preventDefault();
      }
      return;
    }

    // Minutes validation
    if (minutes) {
      minutes = minutes.slice(0, 2);
      if (+minutes > 59) minutes = '59';
    }

    item.dwmDuration = minutes !== undefined ? `${hours}:${minutes}` : hours;
  }

  onDurationBlur(item: any) {
    if (!item.dwmDuration) return;

    let [hours, minutes] = item.dwmDuration.split(':');

    // Auto pad minutes
    if (minutes && minutes.length === 1) {
      minutes = '0' + minutes;
    }

    // Auto pad hours
    if (hours && hours.length === 1) {
      hours = '0' + hours;
    }

    item.dwmDuration = minutes ? `${hours}:${minutes}` : hours;
  }
}
